import { Drawer } from "@mui/material";
import { ReactNode, CSSProperties, forwardRef } from "react";
import { cn } from "../../lib/utils";

export function LeftDrawer({
  children,
  isOpen,
}: {
  children: ReactNode;
  isOpen: boolean;
}) {
  return (
    <Drawer
      anchor="left"
      open={isOpen}
      sx={{
        boxSizing: "border-box",
        "& .MuiDrawer-paper": {
          width: "100%",
          minHeight: "100dvh",
          boxSizing: "border-box",
          overflowY: "scroll",
          display: "flex",
          flexDirection: "column",
          "@media (min-width: 768px)": {
            left: "50% !important",
            right: "auto !important",
            transform: "translateX(-50%) !important",
            maxWidth: "600px",
            width: "600px",
          },
        },
        "& .MuiBackdrop-root": {
          "@media (min-width: 768px)": {
            left: "50% !important",
            right: "auto !important",
            transform: "translateX(-50%) !important",
            maxWidth: "600px",
            width: "600px",
          },
        },
      }}
    >
      {children}
    </Drawer>
  );
}

export const FilterPanelContent = forwardRef<
  HTMLDivElement,
  { children: ReactNode; className?: string; style?: CSSProperties }
>(function FilterPanelContent({ children, className, style }, ref) {
  return (
    <div
      ref={ref}
      className={cn(
        "box-border relative p-[11px_21px] overflow-y-auto flex flex-col [&_.info]:m-[16px_0] [&_.info]:font-dm-sans [&_.info]:text-base [&_.info]:text-primary-black [&_.searchbar]:m-[16px_0]",
        className
      )}
      style={style}
    >
      {children}
    </div>
  );
});

export function FilterPanelHeader({
  children,
  className,
  style,
}: {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={cn(
        "box-border mt-(--safe-area-top) p-[11px_16px] flex bg-white [&_.close-button]:ms-auto",
        className
      )}
      style={style}
    >
      {children}
    </div>
  );
}

export function FilterPanelFooter({
  children,
  className,
  style,
}: {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={cn(
        "box-border p-[21px_22px_calc(21px+var(--safe-area-bottom))] bg-white translate-y-0 transition-transform duration-300 ease-out",
        className
      )}
      style={style}
    >
      {children}
    </div>
  );
}

export function FilterPanelActionBox({
  children,
  className,
  style,
}: {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={cn(
        "flex justify-between [&_.clear-all]:flex [&_.clear-all]:items-center [&_.clear-all]:gap-2 [&_.clear-all]:font-dm-sans [&_.clear-all]:text-sm [&_.clear-all]:font-bold [&_.clear-all]:text-secondary-bluegrey-3 [&_.clear-all_.--custom-icon_svg_rect]:fill-secondary-bluegrey-3 [&_.clear-all.active]:text-secondary-orange-3 [&_.clear-all.active_.--custom-icon_svg_rect]:fill-secondary-orange-3",
        className
      )}
      style={style}
    >
      {children}
    </div>
  );
}

export function SelectableItem({
  children,
  className,
  style,
}: {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={cn(
        "p-[16px_0] flex items-center justify-between gap-4 [&_span]:leading-[130%] [&_span]:font-dm-sans [&_span]:font-bold [&_span]:text-[15px] [&_span]:tracking-[0.02em] [&_span]:text-primary-black",
        className
      )}
      style={style}
    >
      {children}
    </div>
  );
}
